import Vue from 'vue'
import * as jsonpatch from 'fast-json-patch/index.mjs'

const luExciseTransactionType = {
  state: {
    luExciseTransactionType: [],
    selectedLuExciseTransactionType: {},
    selectedLuExciseTransactionTypeOriginal: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    luExciseTransactionType(state) {
      return state.luExciseTransactionType
    },
    selectedLuExciseTransactionType(state) {
      return state.selectedLuExciseTransactionType
    },
    selectedLuExciseTransactionTypeOriginal(state) {
      return state.selectedLuExciseTransactionTypeOriginal
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    luExciseTransactionType(state, payload) {
      state.luExciseTransactionType = payload
    },
    selectedLuExciseTransactionType(state, payload) {
      state.selectedLuExciseTransactionType = JSON.parse(JSON.stringify(payload))
    },
    selectedLuExciseTransactionTypeOriginal(state, payload) {
      state.selectedLuExciseTransactionTypeOriginal = JSON.parse(JSON.stringify(payload))
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedLuExciseTransactionType(context, payload) {
      context.commit('selectedLuExciseTransactionType', payload)
    },
    loadLuExciseTransactionType(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'LuExciseTransactionType'
        Vue.prototype.$axios
        .get(url)
        .then(
          (res) => {
            context.commit('luExciseTransactionType', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          },
        )
      })
    },
    refreshSelectedLuExciseTransactionType(context, payload) {
      if (context.state.selectedLuExciseTransactionType && context.state.selectedLuExciseTransactionType.ID > 0) {
        context.dispatch('loadSelectedLuExciseTransactionType', context.state.selectedLuExciseTransactionType.ID)

      }
    },
    loadSelectedLuExciseTransactionType(context, payload) {
      if (context.state.selectedLuExciseTransactionType && context.state.selectedLuExciseTransactionType.ID != payload) {
        context.commit('selectedLuExciseTransactionType', {})
      }
      return new Promise((resolve, reject) => {
        const url = 'LuExciseTransactionType/' + payload
        context.commit('increaseSearchCount')
        Vue.prototype.$axios
        .get(url)
        .then(
          (res) => {
            context.commit('selectedLuExciseTransactionType', res.data)
            context.commit('selectedLuExciseTransactionTypeOriginal', res.data)
            context.commit('decreaseSearchCount')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('decreaseSearchCount')
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          },
        )
      })
    },
    clearLookupCacheAndReloadLuExciseTransactionType(context, payload) {
      caches.delete('apilookup-cache').finally(() => {
          context.dispatch('loadLuExciseTransactionType')
      }, )
    },
    createLuExciseTransactionType(context, payload){
      return new Promise((resolve, reject) => {
        const url = `LuExciseTransactionType`
        context.commit('saving', true)
        Vue.prototype.$axios
        .post(url, payload)
        .then(
          (res) => {
            context.dispatch('messages/toastMessage',
            {color: 'success', message: 'excise transaction type created',},{ root: true })
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuExciseTransactionType')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          },
        )
      })
    },
    patchLuExciseTransactionType(context, payload){
      return new Promise((resolve, reject) => { 
        var item = context.state.selectedLuExciseTransactionType
        if (payload.ID && 
        payload.ID == context.state.selectedLuExciseTransactionTypeOriginal.ID)  {
        item = payload
        }
        var patchPayload = {}
        if (!payload.patchDoc || !payload.ID) {
          let original = context.state.selectedLuExciseTransactionTypeOriginal
          let current = item
          patchPayload.ID = item.ID
          var diff = jsonpatch.compare(
                original,
                current
              )
          patchPayload.patchDoc = diff

        } else {
          patchPayload = payload
        }
        if (patchPayload.patchDoc.length > 0) {
          const url = `LuExciseTransactionType/${ patchPayload.ID }`
          context.commit('saving', true)
          Vue.prototype.$axios
          .patch(url, patchPayload.patchDoc)
          .then(
            (res) => {
              context.dispatch('messages/toastMessage',
              {color: 'success', message: 'excise transaction type updated',},{ root: true })
              //if you will always need to reload the list after an update
              //you can uncomment out the following dispatch line.
              //Alternatively you can reload whatever object you need
              //when the promise resolves in the component that called it.
              //context.dispatch('loadLuExciseTransactionType')
              context.commit('saving', false)
              resolve(res)
            },
            (err) => {
              console.error(err)
              context.commit('saving', false)
              context.dispatch('errors/handleError', err, { root: true })
              reject(err)
            },
          )
        } else {
          resolve('no changes')
        }
      })
    },
    updateLuExciseTransactionType(context, payload){
      return new Promise((resolve, reject) => { 
        const url = `LuExciseTransactionType/${ payload.ID }`
        context.commit('saving', true)
        Vue.prototype.$axios
        .put(url, payload)
        .then(
          (res) => {
            context.dispatch('messages/toastMessage',
            {color: 'success', message: 'excise transaction type updated',},{ root: true })
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuExciseTransactionType')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          },
        )
      })
    },
    saveLuExciseTransactionType(context, payload){
      return new Promise((resolve, reject) => {
        if (payload.ID > 0) {
          context.dispatch('updateLuExciseTransactionType', payload)
          .then((res) => resolve(res), (err) => reject(err))
        } else {
          context.dispatch('createLuExciseTransactionType', payload)
          .then((res) => resolve(res), (err) => reject(err))
        }
      })
    },
    deleteLuExciseTransactionType(context, payload){
      return new Promise((resolve, reject) => {
        const url = `LuExciseTransactionType/${ payload.ID }`
        Vue.prototype.$axios
        .delete(url)
        .then(
          (res) => {
            context.dispatch('messages/toastMessage',
            {color: 'success', message: 'excise transaction type deleted',},{ root: true })
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuExciseTransactionType')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          },
        )
      })
    },
  },
}

export default luExciseTransactionType